import { SET_LOGIN, USER_DELETE, USER_DETAILS, USER_FORGOT_ONE, USER_FORGOT_TWO, USER_IP, USER_IS_ADMIN, USER_SAVE } from "../actions/action-types";
import { initalState, initialSTateDatasData, initialStateNext } from "../helpers";

// Login
export function LoginReducer(state = initalState, action) {
    switch (action.type) {
        case SET_LOGIN:
            return {
                alert: action.payload.alert,
                isLogin: action.payload.isLog
            }
        default:
            return {
                alert: state.alert,
                isLogin: false
            }
    }
}

// Est-ce que l'utilisateur est admin ?
export function IsAdminReducer(state = initalState, action) {
    switch (action.type) {
        case USER_IS_ADMIN:
            return {
                alert: action.payload.alert,
                isAdmin: action.payload.isAdmin
            }
        default:
            return {
                alert: state.alert,
                isAdmin: false
            }
    }
}

// Mot de passe oublié 1
export function ForgotPwdOneReducer(state = initialStateNext, action) {
    switch (action.type) {
        case USER_FORGOT_ONE:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Mot de passe oublié 2
export function ForgotPwdTwoReducer(state = initialStateNext, action) {
    switch(action.type) {
        case USER_FORGOT_TWO:
            return {
                alert :action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Nouvel utilisateur
export function NewUserReducer(state = initalState, action) {
    switch (action.type) {
        case USER_SAVE:
            return {
                alert: action.payload.alert
            }
        default:
            return {
                alert: state.alert
            };
    }
}

// Supprimer l'utilisateur
export function DelUserReducer(state = initialStateNext, action) {
    switch (action.type) {
        case USER_DELETE:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Obtenir le détail d'un utilisateur
export function DetUserReducer(state = initialSTateDatasData, action) {
    switch (action.type) {
        case USER_DETAILS:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Vérification de l'ip pour la maintenance
export function GetIpUserReducer(state = initalState, action) {
    switch (action.type) {
        case USER_IP:
            return {
                alert: action.payload.alert,
                isCo: action.payload.isCo
            }
        default:
            return {
                alert: state.alert,
                isCo: false
            }
    }
}